import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

export class RoleTypeTranslations {
  static getKey(isBuiltInRole: boolean): string {
    switch (isBuiltInRole) {
      case true:
        return _('Iam.Role.Type.BuiltIn');
      case false:
        return _('Iam.Role.Type.Custom');
    }
  }
}
